module.exports = __webpack_public_path__ + "media/MRI18C.9dfa1219.mp3";